module.exports = __webpack_public_path__ + "img/map.fe875163.png";